export function cubicBezier(x1, y1, x2, y2) {
  return (t) => {
    let guessT = t;
    for (let i = 0; i < 8; i++) {
      const currentX = ((1 - 3 * x2 + 3 * x1) * guessT * guessT * guessT + (3 * x2 - 6 * x1) * guessT * guessT + 3 * x1 * guessT);
      const slope = 3 * (1 - 3 * x2 + 3 * x1) * guessT * guessT + 2 * (3 * x2 - 6 * x1) * guessT + 3 * x1;
      if (Math.abs(slope) < 1e-6) break;
      guessT -= (currentX - t) / slope;
    }
    return ((1 - 3 * y2 + 3 * y1) * guessT * guessT * guessT + (3 * y2 - 6 * y1) * guessT * guessT + 3 * y1 * guessT);
  };
}
